import { USER_ROLES } from '../../auth/index';
import { LAYOUT_VALUES } from '../enums';

const PERMISSIONS = [
	USER_ROLES.CSM,
	USER_ROLES.IMPLEMENTATION,
	USER_ROLES.LANGOS_APP,
	USER_ROLES.OPS,
	USER_ROLES.OWNER,
	USER_ROLES.LANGOPS,
	USER_ROLES.ADMIN,
];

const GLOSSARIES_ROUTES = {
	GLOSSARIES: {
		ACTIVE: true,
		INTERNAL: true,
		NAME: 'manage-glossaries',
		LABEL: 'Glossaries',
		ICON: 'unbabel-logo',
		PARAMS: {
			section: 'glossaries',
		},
		PATH: '/linguistic-resources/glossaries/:section',
		CHILDREN: ['GLOSSARIES_ALL', 'GLOSSARIES_CREATE', 'GLOSSARIES_TERMS'],
		PERMISSIONS,
	},

	GLOSSARIES_ALL: {
		ACTIVE: true,
		NAME: 'glossaries-all',
		LABEL: 'Glossaries List',
		PATH: '/linguistic-resources/glossaries',
		PARAMS: {
			section: '',
		},
		PERMISSIONS,
	},
	GLOSSARIES_CREATE_NEW: {
		ACTIVE: true,
		NAME: 'glossaries-create-new',
		LABEL: 'Create Glossary',
		LAYOUT: LAYOUT_VALUES.FULLSCREEN,
		PARAMS: {
			section: 'create',
		},
		PATH: '/linguistic-resources/glossaries/create-new',
		PERMISSIONS,
	},
	GLOSSARIES_TERMS: {
		ACTIVE: true,
		NAME: 'glossaries-terms',
		LABEL: 'Glossary Terms',
		PARAMS: {
			section: ':glossaryId/terms',
		},
		PATH: '/linguistic-resources/glossaries/:glossaryId/terms',
		PERMISSIONS,
	},
};

const TRANSLATION_MEMORIES_ROUTES = {
	TRANSLATION_MEMORIES_NEW: {
		ACTIVE: true,
		NAME: 'manage-translation-memories',
		LABEL: 'Translation Memories',
		ICON: 'unbabel-translation-memories',
		PARAMS: {
			section: 'translation-memories',
		},
		PATH: '/linguistic-resources/translation-memories/:section',
		CHILDREN: ['TRANSLATION_MEMORIES_CREATE', 'TRANSLATION_MEMORIES_CREATE_MANUAL'],
		PERMISSIONS,
	},
	TRANSLATION_MEMORIES_CREATE: {
		ACTIVE: true,
		NAME: 'translation-memories-create',
		LABEL: 'New entries',
		LAYOUT: LAYOUT_VALUES.FULLSCREEN,
		PARAMS: {
			section: 'create',
		},
		PATH: '/linguistic-resources/translation-memories/create',
		PERMISSIONS,
	},
	TRANSLATION_MEMORIES_CREATE_MANUAL: {
		ACTIVE: true,
		NAME: 'translation-memories-create-manual',
		LABEL: 'New entries',
		LAYOUT: LAYOUT_VALUES.FULLSCREEN,
		PARAMS: {
			section: 'create-manual',
		},
		PATH: '/linguistic-resources/translation-memories/create-manual',
		PERMISSIONS,
	},
	TRANSLATION_MEMORIES_CREATE_UPLOAD: {
		ACTIVE: true,
		NAME: 'translation-memories-create-upload',
		LABEL: 'New entries',
		LAYOUT: LAYOUT_VALUES.FULLSCREEN,
		PARAMS: {
			section: 'create-upload',
		},
		PATH: '/linguistic-resources/translation-memories/create-upload',
		PERMISSIONS,
	},
	TRANSLATION_MEMORIES_CREATE_SEGMENTS: {
		ACTIVE: true,
		NAME: 'translation-memories-create-segments',
		LABEL: 'Create new entries',
		LAYOUT: LAYOUT_VALUES.FULLSCREEN,
		PARAMS: {
			section: 'create-segments',
		},
		PATH: '/linguistic-resources/translation-memories/create-segments',
		PERMISSIONS,
	},
};

const TRANSLATION_MEMORIES_OLD_ROUTES = {
	TRANSLATION_MEMORIES: {
		ACTIVE: true,
		NAME: 'manage-tms',
		LABEL: 'Translation Memories',
		ICON: 'content-flash',
		PARAMS: {
			section: 'tms',
		},
		PATH: '/linguistic-resources/tms/:section',
		CHILDREN: [
			'TRANSLATION_MEMORIES_CURATIONS_LIST',
			'TRANSLATION_MEMORIES_INITIATIONS_LIST',
			'TRANSLATION_MEMORIES_CURATION_DETAILS',
			'TRANSLATION_MEMORIES_INITIATION_DETAILS',
			'TRANSLATION_MEMORIES_NEW_CURATION',
		],
		DISPLAY_CHILDREN: false,
		PERMISSIONS,
	},

	TRANSLATION_MEMORIES_CURATIONS_LIST: {
		ACTIVE: true,
		NAME: 'translation-memories-curations-list',
		LABEL: 'Curations Requested',
		PATH: '/linguistic-resources/tms/curations',
		PARAMS: {
			section: 'curations',
		},
		PERMISSIONS,
	},
	TRANSLATION_MEMORIES_INITIATIONS_LIST: {
		ACTIVE: true,
		NAME: 'translation-memories-initiations-list',
		LABEL: 'Initiations Requested',
		PATH: '/linguistic-resources/tms/initiations',
		PARAMS: {
			section: 'initiations',
		},
		PERMISSIONS,
	},
	TRANSLATION_MEMORIES_CURATION_DETAILS: {
		ACTIVE: true,
		NAME: 'translation-memories-curation-details',
		LABEL: 'Curation Details',
		PATH: '/linguistic-resources/quality-annotations/curations/:curationID',
		PARAMS: {
			section: 'curations/:curationID',
		},
		PERMISSIONS,
	},
	TRANSLATION_MEMORIES_INITIATION_DETAILS: {
		ACTIVE: true,
		NAME: 'translation-memories-initiation-details',
		LABEL: 'Initiation Details',
		PATH: '/linguistic-resources/quality-annotations/initiations/:initiationID',
		PARAMS: {
			section: 'initiations/:initiationID',
		},
		PERMISSIONS,
	},
	TRANSLATION_MEMORIES_NEW_CURATION: {
		ACTIVE: true,
		NAME: 'translation-memories-new-curation',
		LABEL: 'Request Curation',
		PATH: '/linguistic-resources/translation-memories/new-curation',
		PARAMS: {
			section: 'new-curation',
		},
		PERMISSIONS,
	},
};

export default {
	LANGUAGE_RESOURCES: {
		ACTIVE: true,
		NAME: 'manage-language-resources',
		LABEL: 'Linguistic Resources',
		ICON: 'unbabel-logo-circle',
		PATH: '/linguistic-resources/:section',
		CHILDREN: [
			'GLOSSARIES',
			'TRANSLATION_MEMORIES',
			'TRANSLATION_MEMORIES_NEW',
			'LANGUAGE_RESOURCES_FILE_UPLOAD',
		],
		PERMISSIONS,
	},

	...GLOSSARIES_ROUTES,
	...TRANSLATION_MEMORIES_ROUTES,
	...TRANSLATION_MEMORIES_OLD_ROUTES,

	LANGUAGE_RESOURCES_FILE_UPLOAD: {
		ACTIVE: true,
		NAME: 'manage-language-resources-files',
		LABEL: 'Files',
		PARAMS: {
			section: 'files',
		},
		PATH: '/linguistic-resources/files',
		PERMISSIONS,
	},
};
